import axios from 'axios'
import router from '@/router'
import { getHeadersWithAccessToken, getHeadersWithRefreshToken } from '../functions.js'

const service = axios.create({
    baseURL: '',
    headers: getHeadersWithAccessToken()
})

service.interceptors.response.use((response) => {
    return response
}, function (error) {
    const originalRequest = error.config
    if ((error.response.status === 422 || error.response.status === 401) && originalRequest.url.includes('refresh')) {
        console.log('Logout because got 422 or 401 and already retried')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('email')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('superuser')
        localStorage.removeItem('org')
        localStorage.removeItem('groups')
        if (router.app._route.path !== '/user/login') {
            router.push({ name: 'user-login', query: { redirect: router.app._route.path } })
        }
        return Promise.reject(error)
    }

    if ((error.response.status === 422 || error.response.status === 401) && !originalRequest._retry) {
        originalRequest._retry = true
        return axios.post('https://lo7fkmnxt0.execute-api.eu-central-1.amazonaws.com/dev' + '/refresh', {}, { headers: getHeadersWithRefreshToken() })
            .then(res => {
                if (res.status === 200) {
                    localStorage.setItem('access_token', res.data.access_token)
                    localStorage.setItem('expires_at', res.data.expiry)
                    originalRequest['headers'] = getHeadersWithAccessToken() // Need to set new access token of original request
                    return axios(originalRequest)
                }
            })
            .catch(error => {
                if (router.app._route.path !== '/user/login') {
                    router.push({ name: 'user-login', query: { redirect: router.app._route.path } })
                }
                return Promise.reject(error)
            })
    }
    return Promise.reject(error)
})

export default service
